const PLACE_TYPES: {
	[key: string]: {
		[key: string]: string
	}
} = {
	shopping: {
		bicycle_store: 'Fahrradladen',
		book_store: 'Buchladen',
		car_dealer: 'Autohändler',
		clothing_store: 'Bekleidungsgeschäft',
		convenience_store: 'Gemischtwarenladen',
		department_store: 'Kaufhaus',
		drugstore: 'Drogerie',
		electronics_store: 'Elektronikladen',
		florist: 'Floristik',
		furniture_store: 'Möbelladen',
		gas_station: 'Tankstelle',
		hardware_store: 'Eisenwaren',
		home_goods_store: 'Haushaltswaren',
		jewelry_store: 'Juwelier',
		liquor_store: 'Spirituosengeschäft',
		pet_store: 'Tierhandlung',
		shoe_store: 'Schuhladen',
		store: 'Einzelhandel',
		supermarket: 'Supermarkt',
	},
	gastronomy: {
		bakery: 'Bäcker',
		bar: 'Bar',
		cafe: 'Café',
		meal_delivery: 'Essenslieferservice',
		meal_takeaway: 'Essenabholservice',
		night_club: 'Nachtclub',
		restaurant: 'Restaurant',
	},
	service: {
		accounting: 'Steuerbüro',
		atm: 'Geldautomat',
		bank: 'Bank',
		beauty_salon: 'Kosmetiksalon',
		bowling_alley: 'Bowling',
		bus_station: 'Bushaltestelle',
		campground: 'Campingplatz',
		car_rental: 'Autovermietung',
		car_repair: 'Autoreparatur',
		car_wash: 'Autowäsche',
		electrician: 'Elektriker',
		funeral_home: 'Bestattungsunternehmen',
		gym: 'Fitnessstudio',
		hair_care: 'Friseur',
		insurance_agency: 'Versicherungsagentur',
		laundry: 'Waschsalon',
		lawyer: 'Rechtsanwalt',
		library: 'Bibliothek',
		lodging: 'Unterkunft',
		moving_company: 'Umzugsunternehmen',
		painter: 'Maler',
		local_government_office: 'Stadtverwaltung',
		police: 'Polizei',
		post_office: 'Post',
		real_estate_agency: 'Immobilienmakler',
		spa: 'Wellness',
		taxi_stand: 'Taxi',
		travel_agency: 'Reisebüro',
		veterinary_care: 'Tierarzt',
	},
	health: {
		dentist: 'Zahnarzt',
		doctor: 'Arzt',
		hospital: 'Krankenhaus',
		pharmacy: 'Apotheke',
		physiotherapist: 'Physiotherapie'
	},
	other: {
		amusement_park: 'Freizeitpark',
		art_gallery: 'Kunstausstellung',
		cemetery: 'Friedhof',
		church: 'Kirche',
		city_hall: 'Rathaus',
		light_rail_station: 'Stadtbahnhof',
		movie_theater: 'Kino',
		museum: 'Museum',
		park: 'Park',
		parking: 'Parkplatz',
		stadium: 'Stadion',
		tourist_attraction: 'Sehenswürdigkeit',
		train_station: 'Bahnhof'
	}
}

export default PLACE_TYPES;
